import { render, staticRenderFns } from "./risk-item.vue?vue&type=template&id=5128548b&scoped=true"
import script from "./risk-item.vue?vue&type=script&lang=js"
export * from "./risk-item.vue?vue&type=script&lang=js"
import style0 from "./risk-item.vue?vue&type=style&index=0&id=5128548b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5128548b",
  null
  
)

export default component.exports